import classNames from 'clsx';
import { TextField, useMediaQuery, useTheme } from '@material-ui/core';

import { FieldsEnum, LabelEnum } from 'app/shared/enums';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { EndAdornment } from 'app/components/EndAdornment';
import { SortAdornment } from 'app/components/SortAdornment';
import { SelectWithFilterInputProps } from './SelectWithFilterInput.interfaces';

const removeUnneededSpaces = (value: string) =>
  value
    .split(' ')
    .filter((arr) => arr.length > 0)
    .join(' ');

const SelectWithFilterInput = ({
  InputProps,
  classes,
  hasSelectedValue,
  error,
  label,
  onClick,
  focused,
  isOpen,
  disabled,
  readOnly,
  name,
  spaceForAdornmentReserved,
  margin = 'dense',
  inputProps,
  withoutStartAdornment,
  isTravelResultsFilters,
}: SelectWithFilterInputProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(960));
  const isMobile430 = useMediaQuery(theme.breakpoints.down(430));
  const isMobile390 = useMediaQuery(theme.breakpoints.down(390));
  const isStartAdornmentHidden =
    !hasSelectedValue || (focused && !readOnly) || isOpen;
  const isStartAdornmentDisplayNone =
    withoutStartAdornment ||
    (isStartAdornmentHidden && !spaceForAdornmentReserved);
  const StartAdornment =
    name === FieldsEnum.Sort && isTravelResultsFilters
      ? SortAdornment
      : DoneAdornment;
  const shouldShowStaticSortAdornment =
    name === FieldsEnum.Sort && isTravelResultsFilters && isMobile;

  return (
    <TextField
      id={name}
      className={
        isTravelResultsFilters
          ? classes.inputRootTravelResultsFilters
          : classes.root
      }
      variant={'outlined'}
      margin={margin}
      value={removeUnneededSpaces(String(InputProps.value))}
      error={error}
      onClick={onClick}
      label={label}
      name={name}
      InputProps={{
        startAdornment: (
          <>
            {(!shouldShowStaticSortAdornment || !isMobile390) && (
              <StartAdornment
                className={classNames({
                  [classes.adornmentHidden]: isStartAdornmentHidden,
                  [classes.adornmentDisplayNone]: isStartAdornmentDisplayNone,
                })}
              />
            )}
            {shouldShowStaticSortAdornment && (
              <p className={classes.mobileStaticSortAdornment}>{`${
                LabelEnum.Sort
              }${isMobile430 ? ': ' : ''}`}</p>
            )}
          </>
        ),
        endAdornment: !disabled && !readOnly && <EndAdornment open={isOpen} />,
        ...InputProps,
      }}
      InputLabelProps={{
        shrink: isOpen || hasSelectedValue || inputProps?.inputPlaceholder,
        disabled: disabled,
      }}
      inputProps={{
        ...inputProps,
        id: name,
        readOnly: Boolean(inputProps?.readOnly || readOnly),
        inputMode:
          inputProps?.readOnly || readOnly ? ('none' as const) : undefined,
      }}
      autoComplete="off"
    />
  );
};

export default SelectWithFilterInput;
